(function(){
  function init(root){
    if(!root || root.dataset.fbtReady==='true') return;
    root.dataset.fbtReady='true';
    var iframe=root.querySelector('#ogc-tools-iframe');

    window.addEventListener('message',function(event){
      if(!iframe || !event.data || event.data.type!=='resize-iframe') return;
      var height=Number(event.data.height);
      if(!Number.isFinite(height) || height<300) return;
      iframe.style.height=Math.ceil(height)+'px';
      iframe.style.overflow='hidden';
    });

    root.querySelectorAll('[data-guide-accordion]').forEach(function (accordion) {
      accordion.querySelectorAll('details').forEach(function (item) {
        var summary = item.querySelector('summary');

        if (!summary) return;

        summary.addEventListener('click', function (event) {
          event.preventDefault();

          var wasOpen = item.open;

          accordion.querySelectorAll('details[open]').forEach(function (other) {
            other.removeAttribute('open');
          });

          if (!wasOpen) {
            item.setAttribute('open', '');
          }
        });
      });
    });

    var items=root.querySelectorAll('[data-reveal]');
    if(!('IntersectionObserver' in window)){
      items.forEach(function(el){el.classList.add('is-visible')});
    }else{
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      },{threshold:.12});
      items.forEach(function(el){io.observe(el)});
    }

    if(window.lucide) window.lucide.createIcons();
    else window.addEventListener('load',function(){if(window.lucide) window.lucide.createIcons()},{once:true});
  }

  function initAll(){document.querySelectorAll('[data-ogc-fbt-page]').forEach(init)}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initAll);
  else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();